<form *ngIf="workerSeizureAmmountFormGroup" [formGroup]="workerSeizureAmmountFormGroup">
    <div class="grid">
      <div class="col-12 input-field ">
            <label for="date">Fecha *</label>
            <p-calendar [firstDayOfWeek]="1" inputId="date" appendTo="body" dateFormat="dd/mm/yy" formControlName="date"
                d-form-field-error />
        </div>
        <div class="col-12 input-field">
            <label for="ammount">Importe *</label>
            <input pInputText type="number" name="ammount" formControlName="ammount" d-form-field-error/>
          </div>        
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && workerSeizureAmmount.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>